import React from "react";

interface HeaderProps {
  data: {
    title: string;
    lastUpdated: string;
    runningTotal: string;
  };
}

const Header: React.FC<HeaderProps> = ({ data }) => {
  return (
    <div className="header">
      <div className="header-left">
        <h1 className="header-title">{data.title}</h1>
        <div className="header-meta">
          <span className="header-meta-item">
            <span className="header-meta-label">Last Updated:</span>{" "}
            {data.lastUpdated}
          </span>
          <span className="header-meta-divider">|</span>
          <span className="header-meta-item">
            <span className="header-meta-label">Running Total:</span>{" "}
            {data.runningTotal}
          </span>
        </div>
      </div>
      <div className="header-right">
        <button className="header-upload-btn">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1v8M4 4l3-3 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M1 10v1.5A1.5 1.5 0 0 0 2.5 13h9A1.5 1.5 0 0 0 13 11.5V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
          File Upload
        </button>
      </div>
    </div>
  );
};

export default Header;
